module.exports = __webpack_public_path__ + "fonts/Montserrat_SemiBold_Latin_Ext.f44682aa.woff2";